document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".wtb-search") || document.getElementById("wtbModal")) {
        import(/* webpackChunkName: "where-to-buy" */ "/Features/WhereToBuy/js/where-to-buy.js").then(async (module) => {
            const whereToBuy = new module.default();
            window.whereToBuy = whereToBuy;
            await whereToBuy.init();
        });
    }
});
